var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_vm.layout,{tag:"component"},[_c('router-view'),_c('SignInDialogue',{ref:"signInDialogue",on:{"is-authenticated":_vm.onAuthenticated}}),_c('error-message',{attrs:{"options":_vm.errorMessageOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }